// import { useRef, useEffect } from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";


const Gallery = ({ items }) => {

    return <ImageGallery
        lazyLoad={true}
        items={items}
    />;
};

export default Gallery;
